<h4 [class]="role === 'owner' ? 'active' : status" (mouseenter)="hover = true" (mouseleave)="hover = false">
    {{capitalizeFirstChar(hover ? status : role)}}
</h4>